import { CircleUserRound, LogOut, ShoppingCart } from 'lucide-react';
import { NavLink, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import { useEffect, useState } from 'react';

function isActiveClass({ isActive }) {
  return `nav-item ${isActive ? 'active' : ''}`;
}

function profileClass({ isActive }) {
  return `user-pill ${isActive ? 'active' : ''}`;
}

export default function Header() {
  const { user, logout } = useAuth();
  const { totalItems } = useCart();
  const [hidden, setHidden] = useState(false);
  const [lastScroll, setLastScroll] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.scrollY;
      if (currentScroll > lastScroll && currentScroll > 100) {
        setHidden(true);
      } else {
        setHidden(false);
      }
      setLastScroll(currentScroll);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScroll]);

  return (
    <header className={`header-wrap ${hidden ? 'header-hidden' : ''}`}>
      <div className="sale-strip">Premium Pixel Speaker | Prepaid only | Free shipping</div>

      <div className="top-nav">
        <Link to="/" className="brand-logo" aria-label="raojatin.shop home">
          <img
            src="/logo.png"
            alt="raojatin.shop logo"
            onError={(event) => {
              event.currentTarget.style.display = 'none';
            }}
          />
          <span>RAOJATIN.SHOP</span>
        </Link>

        <nav className="main-nav">
          <NavLink to="/" className={isActiveClass} end>
            Home
          </NavLink>
          <NavLink to="/product" className={isActiveClass}>
            Product
          </NavLink>
          <NavLink to="/cart" className={isActiveClass}>
            Cart
          </NavLink>
        </nav>

        <div className="nav-actions">
          {user ? (
            <div className="auth-actions">
              <NavLink to="/profile" className={profileClass} title={user.email || 'Logged in'}>
                <CircleUserRound size={14} />
                <span>{user.displayName || 'My Profile'}</span>
              </NavLink>
              <button type="button" className="ghost-btn" onClick={logout}>
                <LogOut size={14} /> Logout
              </button>
            </div>
          ) : (
            <div className="auth-actions">
              <NavLink to="/login" className="ghost-btn">
                Login
              </NavLink>
              <NavLink to="/signup" className="solid-btn">
                Sign up
              </NavLink>
            </div>
          )}

          <NavLink to="/cart" className="cart-pill" aria-label="Open cart">
            <ShoppingCart size={16} />
            <span>Cart</span>
            <strong>{totalItems}</strong>
          </NavLink>
        </div>
      </div>
    </header>
  );
}
